var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeI"},[_c('el-form',{ref:"myProfileForm",attrs:{"label-position":"top","label-width":"130px"},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-card',{staticClass:"box-card mb-3 text-center"},[_c('h3',[_vm._v("Đang phát triển")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }